var map = {
	"./alert.mp3": 63629,
	"./apron-time.mp3": 98356,
	"./awoogah.mp3": 74074,
	"./bliss-gliss.mp3": 21547,
	"./chirp.mp3": 50880,
	"./coo-coo.mp3": 55860,
	"./fog-horn.mp3": 79205,
	"./giggles.mp3": 39275,
	"./gong.mp3": 7335,
	"./new-age.mp3": 34298,
	"./soprano.mp3": 32685,
	"./the-dinga-ding-song.mp3": 38769,
	"./ting.mp3": 17253,
	"./whistle.mp3": 73984,
	"./whoooo.mp3": 93918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24659;